// src/components/Avatar.jsx
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './Avatar.css';
import { resolveMediaUrl } from '../utils/media.js';

function normalizeAvatarSource(value) {
  if (typeof value !== 'string') return null;
  const trimmed = resolveMediaUrl(value);
  return trimmed || null;
}

function getFirstInitial(name) {
  if (!name || typeof name !== 'string') return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  const [firstChar = '?'] = Array.from(trimmed);
  return firstChar.toUpperCase();
}

export default function Avatar({
  name = '',
  photo,
  src,
  alt,
  size = 40,
  className = '',
}) {
  const resolvedPhoto = normalizeAvatarSource(src ?? photo ?? null);
  const [error, setError] = useState(false);

  const showImg = resolvedPhoto && !error;
  const initials = useMemo(() => getFirstInitial(name), [name]);
  const fontSize = Math.max(12, Math.round(size * 0.48));
  const altText = alt || (name ? `Foto de ${name}` : 'Avatar');

  useEffect(() => {
    setError(false);
  }, [resolvedPhoto]);

  const handleImageError = useCallback(() => {
    setError(true);
  }, []);

  const style = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    fontSize,
  };

  return (
    <div className={`avatar ${className}`} style={style} aria-label={name}>
      {showImg ? (
        <img
          src={resolvedPhoto}
          alt={altText}
          className="avatar-image"
          onError={handleImageError}
        />
      ) : (
        <div className="avatar-initials" aria-hidden="true">
          {initials}
        </div>
      )}
    </div>
  );
}
